export default __webpack_public_path__ + "static/media/bcel-commerce.0dcfcbf1.png";